module.exports = __webpack_public_path__ + "static/4-66ee5f1cb55c10326e25e120fea94b9a.jpg";